import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();

  // Check token existence first
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  // Check if token is expired
  if (authService.isAuthenticated() === false) {
    // isAuthenticated returns false and clears expired tokens
    return <Navigate to="/login" replace />;
  }

  // Force redirect to profile page if user must change password
  const currentUser = authService.getCurrentUser();
  if (currentUser?.mustChangePassword && location.pathname !== '/profile') {
    return <Navigate to="/profile" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;